import VerificationLoader from './VerificationLoader'

export default VerificationLoader
